import axios, { AxiosInstance } from "axios";
import config from "../config";
import { setupAuthInterceptor } from "../utils";

export const createProjectService = (): AxiosInstance => {
  const projectService = axios.create({
    baseURL: config.projectServiceURL,
  });

  setupAuthInterceptor(projectService);

  return projectService;
};

const projectService = createProjectService();

export { projectService };
